import { render, staticRenderFns } from "./productIndex.vue?vue&type=template&id=1e1bc10e&scoped=true&"
import script from "./productIndex.vue?vue&type=script&lang=js&"
export * from "./productIndex.vue?vue&type=script&lang=js&"
import style0 from "./productIndex.vue?vue&type=style&index=0&id=1e1bc10e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1bc10e",
  null
  
)

export default component.exports